<!-- <div class="header"></div> -->
<div class="site-container">
    <app-ui-header-layout-main></app-ui-header-layout-main>


    <br>
    <div class="contest-text-content">
        <div class="contest-text-box">
            <div class="contest-header">
                <hr><span>“III. Heykelde Yeni Keşifler” Yarışması
                    Sonuçlandı</span>
            </div>
            <div class="contest-text">
                <div class="contest-head">
                    <p>Milliyet Sanat'ın Heykelde Yeni Keşifler Yarışması Sonuçları Belli Oldu
                </div>
                <div class="contest-explain">Türkiye’nin 50 yıllık en köklü sanat ve kültür dergisi
                    Milliyet Sanat’ın, heykel sanatının gelişimine katkıda bulunmak amacıyla hayata geçirdiği ve Mesa
                    Holding’in sponsorluğunda gerçekleştirilen “III. Heykelde Yeni Keşifler” yarışması sonuçlandı.
                    Seçici
                    kurul tarafından belirlenen eserler içerisinden dereceye giren üç sanatçı seçilen eserleri ile 15
                    bin TL
                    üretim desteği almaya hak kazandı. Eserler Eylül 2023’te açılacak sergi sanatseverler ile buluşacak.
                </div>
            </div>
            <div class="contest-list-content">
                <div class="contest-list">
                    <div class="contest-list-text">
                        <div class="contest-list-explain">Türkiye’nin en köklü kültür sanat yayını
                            olan Milliyet Sanat'ın yetenekli sanatçıları desteklemek amacıyla hayata geçirdiği “Heykelde
                            Yeni Keşifler” yarışmasının kazananları belirlendi. Birbirinden değerli isimlerin yer aldığı
                            yarışmada seçici kurulun değerlendirmesi ile 10 eser seçildi. Bu eserler arasından Furkan
                            Depeli
                            "Dialouge, khronos" eseriyle, Can Aksan "Jah - Protection" eseriyle ve Çiğdem Yıldırım ise
                            "Athena" isimli eseriyle 15 bin TL üretim desteği kazandı.
                            Heykelde Yeni Keşifler Sergisi katılımcıların başarılı işlerini sanatseverler ile
                            buluşturmada
                            önemli bir fırsat sunuyor.
                        </div>
                    </div>
                </div>
                <div class="contest-list">
                    <div class="contest-list-text">
                        <div class="contest-list-head">Milliyet Sanat ve Mesa Özel Ödülü yurtdışı
                            eğitimi</div>
                        <div class="contest-list-explain">Sanata ve sanatçıya her zaman destek olan ve
                            sosyal sorumluluk vizyonu doğrultusunda en önemli evrensel değerlerden kültür ve sanata
                            öncelik
                            veren MESA Holding’in sponsorluğunda gerçekleşen ‘Heykelde Yeni Keşifler Yarışması’nda, 2
                            sanatçı yurtdışında 1’er ay sanat eğitimi almaya hak kazanacak. Kazanan sanatçılar , söz
                            konusu
                            eğitimle farklı bakış açılarını görme ve çalışmalarını geliştirme şansı yakalayacak. Yurt
                            dışı
                            atölye eğitimi hakkı kazanan sanatçılar Haziran ayı içerisinde açıklanacak. <br><br>
                            İlki 2019 yılında gerçekleşen yarışmanın bu seneki seçici kurulunda Artsümer Galeri Kurucusu
                            Aslı Sümer, Koleksiyoner Berrak Barut, Küratör & Sanat Yazarı Derya Yücel, Limak Yatırım
                            Yönetim
                            Kurulu Başkanı & Koleksiyoner Ebru Özdemir, Milliyet Sanat Dergisi Genel Yayın Yönetmeni
                            Filiz
                            Aygündüz, Küratör, Yazar, Akademisyen & Sanat Danışmanı Melike Bayık, Demirören Holding
                            Yönetim
                            Kurulu Başkan Yardımcısı & Koleksiyoner Meltem Demirören, Mimar Sinan Güzel Sanatlar
                            Üniversitesi Heykel Bölüm Başkanı Prof. Neslihan Pala, Merkur Galeri Kurucusu & Sanat
                            Danışmanı
                            Sabiha Kurtulmuş, Sanatçı Seçkin Pirim ve Mesa Mesken Projeler Tasarım Koordinatörü Sinem
                            Konu
                            Keskinok yer alıyor.
                        </div>
                    </div>
                </div>
                <div class="contest-list">
                    <div class="contest-list-text">
                        <div class="contest-list-head">2022 Heykelde Yeni Keşifler - Dereceye Giren
                            Sanatçılar (Alfabetik)</div>
                        <div class="contest-list-explain">
                            <table class="last-year-top-list">
                                <thead>
                                    <th>Sanatçı</th>
                                    <th>Eser Adı</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Abdulsamed Şahin </td>
                                        <td>Ayağı Bağlı</td>
                                    </tr>
                                    <tr>
                                        <td>Can Aksan </td>
                                        <td>Jah - Protection</td>
                                    </tr>
                                    <tr>
                                        <td>Çiğdem Yıldırım </td>
                                        <td>Athena</td>
                                    </tr>
                                    <tr>
                                        <td>Emirhan Özkök </td>
                                        <td>İris</td>
                                    </tr>
                                    <tr>
                                        <td>Filiz Sır </td>
                                        <td>Entropi</td>
                                    </tr>
                                    <tr>
                                        <td>Furkan Depeli </td>
                                        <td>Dialogue, khronos</td>
                                    </tr>
                                    <tr>
                                        <td>Kadir Kırıcı</td>
                                        <td>Dönence Kendini Tanı</td>
                                    </tr>
                                    <tr>
                                        <td>Lale Altunel </td>
                                        <td>Lilium</td>
                                    </tr>
                                    <tr>
                                        <td>Olcay Gültepe </td>
                                        <td>Hayalperest</td>
                                    </tr>
                                    <tr>
                                        <td>Ufuk Aydın </td>
                                        <td>İçgörüsel Yapı</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="jury-content">
        <div class="jury-left-content">
            <div class="jury-left-text">
                <hr>
                <span>Seçici <br> Kurul</span>
            </div>
        </div>
        <div class="jury-right-content">

            <!--Seçici Kurulun Listesi baştan çekebilirsin.-->

            <!-- Seçici Kurul alanındaki listeyi düzenledim.-->
            <div class="jury-list-content">
                <div class="jury-list">
                    <a data-target="#asliSumerModal" data-toggle="modal">
                        <div class="jury-name">Aslı Sümer</div>
                        <div class="jury-title">Artsümer Galeri Kurucusu</div>
                    </a>
                </div>

                <div class="jury-list"><a data-target="#berrakBulutModal" data-toggle="modal">
                        <div class="jury-name">Berrak Barut</div>
                        <div class="jury-title">Koleksiyoner</div>
                    </a></div>
                <div class="jury-list"><a data-target="#deryaYucelModal" data-toggle="modal">
                        <div class="jury-name">Derya Yücel</div>
                        <div class="jury-title">Küratör / Sanat Yazarı</div>
                    </a></div>
                <div class="jury-list"><a data-target="#ebruOzdemirModal" data-toggle="modal">
                        <div class="jury-name">Ebru Özdemir</div>
                        <div class="jury-title">Limak Yatırım Yönetim Kurulu Başkanı / Koleksiyoner</div>
                    </a></div>
                <div class="jury-list"><a data-target="#filizAygunduzModal" data-toggle="modal">
                        <div class="jury-name">Filiz Aygündüz</div>
                        <div class="jury-title">Milliyet Sanat Dergisi Genel Yayın Yönetmeni</div>
                    </a></div>
                <div class="jury-list"><a data-target="#melikeBayikModal" data-toggle="modal">
                        <div class="jury-name">Melike Bayık</div>
                        <div class="jury-title">Küratör / Yazar / Sanat Danışmanı / Akademisyen</div>
                    </a></div>
                <div class="jury-list"><a data-target="#meltemDemirorenOktayModal" data-toggle="modal">
                        <div class="jury-name">Meltem Demirören</div>
                        <div class="jury-title">Demirören Holding Yönetim Kurulu Başkan Yardımcısı /
                            Koleksiyoner
                        </div>
                    </a></div>
                <div class="jury-list"><a data-target="#neslihanPalaModal" data-toggle="modal">
                        <div class="jury-name">Prof. Neslihan Pala</div>
                        <div class="jury-title">Mimar Sinan Güzel Sanatlar Üniversitesi Heykel Bölüm Başkanı</div>
                    </a></div>
                <div class="jury-list"><a data-target="#sabihaKurtulmusModal" data-toggle="modal">
                        <div class="jury-name">Sabiha Kurtulmuş</div>
                        <div class="jury-title">Merkur Galeri Kurucusu / Sanat Danışmanı</div>
                    </a></div>
                <div class="jury-list"><a data-target="#seckinPirimModal" data-toggle="modal">
                        <div class="jury-name">Seçkin Pirim</div>
                        <div class="jury-title">Sanatçı</div>
                    </a></div>
                <div class="jury-list"><a data-target="#sinemKonuKeskinok" data-toggle="modal">
                        <div class="jury-name">Sinem Konu Keskinok</div>
                        <div class="jury-title">Mesa Mesken Sanayi A.Ş. / Projeler Tasarım Koordinatörü</div>
                    </a></div>
            </div>
        </div>
    </div>

    <br />

    <div class="contest-text-content">
        <div class="contest-text-box">
            <ul class="nav nav-tabs">
                <li class="active"><a data-toggle="tab" href="#kesif-2022">2022 Keşifleri</a></li>
                <li><a data-toggle="tab" href="#kesif-2021">2021 Keşifleri</a></li>
                <li><a data-toggle="tab" href="#kesif-2019">2019 Keşifleri</a></li>
            </ul>

            <div class="tab-content">
                <div id="kesif-2022" class="tab-pane fade in active">
                    <div class="contest-text-box">
                        <div class="contest-text-explain">III. HEYKELDE YENİ KEŞİFLER YARIŞMASININ
                            ÖDÜL TÖRENİ
                            GERÇEKLEŞTİ!
                        </div>
                        <p>
                            <strong>
                                Türkiye’nin en köklü  kültür sanat dergisi Milliyet Sanat’ın bu yıl
                                üçüncüsünü düzenlediği Heykelde  Yeni Keşifler yarışmasının ödül ve
                                kapanış töreni 14 Ekim 2023 Kemer Country  Club’da gerçekleşti! Seçici
                                kurul tarafından belirlenen eserlerin  sanatseverlerle buluştuğu
                                serginin sonunda gerçekleşen törene Özay Şendir,  Doğan Hızlan, Emre
                                İskeçeli, Ozan Turhan, Olgaç Artam, Sabiha Kurtulmuş, Asu  Maro, Gamze
                                Çetiner, Derya Yücel, Aslı Sümer, Sinem Konu Keskinok’un da  aralarında
                                olduğu çok sayıda isim katıldı. MESA Holding’in sponsorluğunda
                                gerçekleştirilen III. Heykelde Yeni Keşifler yarışmasında dereceye giren
                                sanatçılara plaketleri Milliyet Sanat Dergisi Genel Yayın Yönetmeni
                                Filiz  Aygündüz tarafından takdim edilirken yurtdışında sanat eğitimi
                                atölyesi kazanan  isim ise Furkan Depeli oldu.
                            </strong>
                        </p>
                        <p>
                            <strong>
                                <img
                                    width="276"
                                    height="187"
                                    src="assets/img/2022/2022-6.jpg"
                                />
                            </strong>
                            <strong></strong>
                        </p>
                        <p>
                            <strong></strong>
                        </p>
                        <p>
                            <strong>Milliyet Sanat</strong>’ın 2019 yılından bu yana düzenlediği
                            <strong>Heykelde Yeni Keşifler</strong> yarışması, henüz keşfedilmemiş
                            yetenekleri desteklemeyi, heykel sanatçılarının  görünürlüğünü artırmayı,
                            özellikle galerilerde temsiliyeti olmayan sanatçılara  yeni kapılar açmayı
                            ve böylece heykel sanatına yeni değerler kazandırmayı  amaçlıyor. Kazanan
                            yarışmacılara üretim desteği ve sergileme imkânı tanınan  yarışmada,
                            belirlenen 10 finalist arasından ilk 3’e giren yarışmacıların her  biri 15
                            bin TL üretim desteği almaya hak kazanıyor. Katılımda yaş ve eğitim
                            sınırının bulunmadığı <strong>III. Heykelde Yeni Keşifler</strong>, önceki
                            yıl olduğu  gibi bu yıl da yine <strong>MESA Holding</strong>’in
                            sponsorluğunda düzenlendi.
                        </p>
                        <p>
                            <strong>
                                <img
                                    width="297"
                                    height="202"
                                    src="assets/img/2022/2022-5.jpg"
                                    alt=""
                                />
                            </strong>
                        </p>
                        <p>
                            <strong></strong>
                        </p>
                        <p>
                            <strong>III. Heykelde Yeni  Keşifler</strong> yarışmasının,
                            <strong>
                                Kemer Country Club
                            </strong>
                            ’da  gerçekleşen sergisinde; <strong>Aslı Sümer</strong>,<strong>Berrak
                            Barut</strong>, <strong>Derya Yücel</strong>, <strong>Ebru
                            Özdemir</strong>,<strong>Filiz Aygündüz</strong>,<strong>Melike Bayık</strong>,<strong>Meltem 
                            Demirören</strong>,<strong>Prof. Neslihan Pala</strong>,
                            <strong>
                                Sabiha Kurtulmuş
                            </strong>
                            ,<strong>Seçkin Pirim</strong>ve <strong>Sinem Konu Keskinok</strong>’tan
                            oluşan seçici kurul tarafından  belirlenen 10 eser sanatseverlerle buluştu.
                        </p>
                        <p>
                            <img
                                width="197"
                                height="293"
                                src="assets/img/2022/2022-4.jpg"
                            />
                            <strong>
                                <img
                                    width="236"
                                    height="294"
                                    src="assets/img/2022/2022-3.jpg"
                                />
                            </strong>
                            <strong></strong>
                        </p>
                        <p>
                            <strong></strong>
                        </p>
                        <p>
                            <strong>III. Heykelde Yeni  Keşifler</strong>’in ödül ve kapanış töreni ise
                            14 Ekim 2023  Cumartesi<strong></strong>günü<strong>Kemer Country Club</strong>’da 
                            özel bir davetle  gerçekleşti. Törenin açılış konuşmasını, aynı zamanda
                            serginin küratörlüğünü  üstlenen <strong>Sabiha Kurtulmuş</strong> yaptı.
                            Yarışmanın heykel sanatı için önemine  ve eserlere değinen
                            <strong>
                                Kurtulmuş
                            </strong>
                            <em>
                                “Milliyet  Sanat’ın Mesa Holding sponsorluğunda düzenlediği III.
                                Heykelde Yeni Keşifler  yarışması ve yarışmanın, Kemer Country Club ev
                                sahipliğinde gerçekleşen sergisi,  sanatçıları desteklemeyi hedefleyen
                                bir proje. Her yıl farklı desteklerle ve  yeniliklerle düzenliyoruz bu
                                yarışmayı. Bu sene seçici kurul tarafından  belirlenen eserler
                                içerisinden dereceye giren üç sanatçıya, çalışmalarının  üretimi için 15
                                bin TL üretim desteği sağladık. Bir önceki yarışmamızda olduğu  gibi
                                birincilik ödülü alan sanatçımıza yurt dışında ‘Somos International
                                Artist  In Residence Program Agreement’ta 1 ay sanat eğitimi imkânı
                                sağlayarak destek  oluyoruz. Eğitimi özellikle çok önemsiyoruz. Bir
                                sanatçının farklı bir ülkenin  ve kültürün sanat ortamıyla bir araya
                                gelmesi, etkileşimde bulunması ve hem  deneyimlediklerini hem de
                                öğrendiklerini sanatına aktarabilmesi çok önemli,”
                            </em>
                            şeklinde konuştu.
                        </p>
                        <p>
                            <img
                                width="310"
                                height="203"
                                src="assets/img/2022/2022-2.jpg"
                            />
                        </p>
                        <p>
                            Yarışmada  dereceye giren sanatçılara plaketleri verilirken, yurtdışında
                            <strong>
                                “Somos  International Artist In Residence Program Agreement”
                            </strong>
                            ta bir ay sanat eğitimi  almaya hak kazanarak farklı bakış açılarını görme
                            ve çalışmalarını geliştirme  şansı yakalayan <strong>Furkan Depeli</strong>
                            ise ödülünü <strong>Filiz Aygündüz</strong>’ün elinden aldı.
                        </p>
                        <p>
                            <img
                                width="193"
                                height="247"
                                src="assets/img/2022/2022-1.jpg"
                            />
                        </p>
                    </div>
                </div>
                <div id="kesif-2021" class="tab-pane fade">
                    <div class="contest-text-box">
                        <div class="contest-text-explain">II. HEYKELDE YENİ KEŞİFLER 2021</div>
                        Milliyet Sanat dergisinin
                        heykel sanatının gelişimine katkıda bulunmak amacıyla hayata geçirdiği ‘II. Heykelde Yeni
                        Keşifler’
                        yarışmasında
                        seçici kurulun belirlediği 10 eser, Kemer Country’de yapılan özel açılış etkinliği ile
                        sanatseverle
                        buluştu.<br><br>Türkiye’nin en köklü kültür sanat yayını olan
                        Milliyet Sanat’ın
                        yetenekli sanatçıları desteklemek amacıyla hayata geçirdiği ‘Heykelde Yeni Keşifler’
                        yarışmasının sonucunda
                        dereceye
                        giren eserler özel bir sergi ile sanatseverlerle buluştu. Ece Üner’in sunumuyla gerçekleştirilen
                        etkinliğin
                        açılış
                        konuşmasını <a href="https://www.hurriyet.com.tr/haberleri/milliyet-sanat-dergisi"
                            target="_blank">Milliyet Sanat Dergisi</a> Genel Yayın Yönetmeni Filiz Aygündüz yaptı.
                        Aygündüz’ün
                        ardından
                        yarışmanın bu seneki sponsorluğunu üstlenen Mesa Mesken’in Yönetim Kurulu Başkanı Mert
                        Boysanoğlu yarışmanın
                        bir
                        parçası oldukları için mutlu olduklarını belirtti.<br><br><img _ngcontent-lcv-c52=""
                            alt="İşte heykelin yeni keşifleri 2 Görsel" src="assets/img/2-320x480.jpg"
                            class="img-responsive"><br><br><b>ESERLER SATIŞA SUNULDU</b><br>
                        Yurtdışı atölye eğitimi ödülünü
                        kazanan sanatçı ise Burak Ayazoğlu oldu ve ödülünü Revna Demirören’in elinden aldı.<br><br>
                        Plaket töreninin ardından, Heykelde Yeni Keşifler
                        yarışmasının seçici kurul üyeleri
                        Sabiha Kurtulmuş ve Seçkin Pirim tarafından dereceye giren eserlerin hikayeleri sergiye gelen
                        konuklarla
                        paylaşılarak satışa sunuldu.<br><br> 24 Kasım tarihine kadar
                        devam eden
                        sergi Kemer Country ev sahipliğinde ziyaretçiler ile buluştu. Birbirinden başarılı eserleri bir
                        araya
                        getiren bu
                        özel güne sanat ve cemiyet hayatından bir çok önemli isim katıldı.<br><br> Heykelde Yeni
                        Keşifler Seçici Kurul Üyeleri bu yıl Aslı Sümer, Derya Yücel, Ebru
                        Özdemir,
                        Fabio Antinori Lattanzi, Filiz Aygündüz, Melike Bayık, Meltem Demirören, Prof. Neslihan
                        Pala, Sabiha
                        Kurtulmuş, Seçkin Pirim ve Sinem Konu Keskinok’tan oluştu.<br><br><img _ngcontent-lcv-c52=""
                            alt="İşte heykelin yeni keşifleri 1 Görsel" src="assets/img/1-360x240.jpg"
                            class="img-responsive"><br><br><b>Ödüllerini Aldılar</b><br><img
                            alt="İşte heykelin yeni keşifleri Genel Resim Görsel"
                            src="assets/img/genel-resim-340x200.jpg" class="img-responsive"><br> Açılış
                        konuşmalarının tamamlanmasının ardından eserleri
                        sergilenen sanatçılara plaketleri takdim edildi. Heykelde Yeni Keşifler Seçici Kurul Üyesi
                        Seçkin Pirim,
                        ‘İsimsiz’
                        adlı eseri ile Burak Ayazoğlu’na; Milliyet Sanat Dergisi Genel Yayın Yönetmeni Filiz Aygündüz,
                        ‘Kabuk’ adlı
                        eseri
                        ile Eda İlbeyci ve ‘Hep Birlikte’ adlı eseri ile Funda Çetgin’e; Mesa Mesken Yönetim Kurulu
                        Başkanı Mert
                        Boysanoğlu,
                        ‘World Wide Web’ adlı eseri ile Güliclal Öner Yıldız’a; Demirören Holding Yönetim Kurulu Üyesi
                        Murat Oktay,
                        ‘Davet’
                        adlı eseri ile Güngör Yüksel ve ‘Dar Alanda Kısa Paslaşmalar III’ adlı eseri ile Koray
                        Bıyıklı’ya; Demirören
                        Holding
                        Yönetim Kurulu Üyesi Erdoğan Demirören, ‘Omurga’ adlı eseri ile Muzaffer Tuncer ve ‘Güzel avrat
                        otu ile oto
                        portre’
                        adlı eseri ile Sesil Beatris Kalaycıyan’a; Demirören Holding Yönetim Kurulu Başkanı Yıldırım
                        Demirören’in
                        eşi Revna
                        Demirören ise ‘d=c+v+s’ adlı eseri ile Şirvan Güngörmez’e plaketlerini takdim etti.
                    </div>
                </div>
                <div id="kesif-2019" class="tab-pane fade">
                    <div class="contest-text-box">

                        <div class="contest-text-explain">I. HEYKELDE YENİ KEŞİFLER 2019</div>
                        <div class="contest-text-explain">
                            Milliyet Sanat, 2019 yılında ‘Heykelde Yeni Keşifler’ yarışması ve sergisinin ilkini hayata geçirdi
                        </div>
                        Türkiye’nin 50 yıldır yayın hayatını sürdüren sanat dergisi Milliyet Sanat, genç heykel sanatçılarının
                        görünürlüğünü desteklemek, heykel sanatına yeni değerler kazandırmak amacı ile 2019 yılında ‘Heykelde Yeni
                        Keşifler’ yarışması ve sergisinin ilkini hayata geçirdi. Türkiye’nin dört bir yanından 200’e yakın
                        sanatçının eserleri ile başvurduğu yarışma sonucu 10 eser sergilenmeye hak kazandı.
                        <br><br>
                        “Heykelde Yeni Keşifler” sergisi için sanatçılar, seçici kurul üyeleri ve sanatseverler bir araya geldi.
                        Milliyet Sanat dergisi tarafından Kemer Country Club iş birliğiyle düzenlenen "Heykelde Yeni Keşifler"
                        yarışması kapsamında dereceye giren ve yaz boyunca Kemer Country Hotel'in bahçesinde sergilenen 10 eser yine
                        aynı alanda düzenlenen müzayedeyle satışa sunuldu. Müzayedeyi, 20. yüzyılın başlarından bu yana, dört
                        kuşaktır Türkiye'nin sanat ve kültür hayatına büyük katkıda bulunan Portakal Ailesi’nin dördüncü kuşak
                        temsilcisi, müzayedeciliğin duayenlerinden Rafi Portakal’ın kızı, gerçekleştirdiği ve yönettiği başarılı
                        müzayedeleriyle de tanıdığımız Portakal Sanat ve Kültür Evi Direktörü, Yönetim Kurulu Üyesi Maya Portakal
                        Bitargil yönetti.
                        <br><br>
                        Alışılagelmiş müzayede anlayışından farklı olarak sessiz müzayedeyle ilerleyen Bitargil, interaktif bir
                        yöntemle yönettiği müzayedeye başlamadan önce heykellerin yanına giderek, eserlerin hikayelerini tek tek
                        anlattı. <br><br>
                        “Heykelde Yeni Keşifler" yarışması danışmanı Sabiha Kurtulmuş ise müzayedeye ilişkin şunları kaydetti.
                        “Buradaki amaç, katılan heykel sanatçılarını desteklemek. Aynı zamanda ayrılacak küçük bir katkı payıyla da
                        önümüzdeki sene yeni heykel projelerine destek olmak istiyoruz” dedi.
            
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <!-- 
    <div class="how-to-join-content">
        <div class="left-text-content">
            <div class="left-head-text">Yarışmaya Nasıl Katılabilirim?</div>
            <div class="left-explain-text">Katılım koşullarını bu linkten inceleyebilirsiniz</div>
        </div>
        <div class="right-text-content">
            <div class="right-text-box">
                <a href="basvuru-yonetmelik">
                    <span>Yarışma Katılım Koşulları</span>
                </a>
            </div>
        </div>
    </div> -->

    <div class="contest-slider-content">
        <ul class="nav nav-tabs">
            <li  class="active"><a data-toggle="tab" href="#liste-2022">2022 Keşifleri</a></li>
            <li><a data-toggle="tab" href="#liste-2021">2021 Keşifleri</a></li>
        </ul>
        <div class="tab-content">

            <div id="liste-2021" class="tab-pane fade">
                <div class="contest-slider-head">İşte 2021'de dereceye giren eserler</div>
                <div class="contest-slider-explain">Milliyet Sanat Dergisi tarafından düzenlenen “Heykelde Yeni
                    Keşifler” yarışmasında dereceye giren ve müzayede de sahipleri ile buluşan eserler.
                </div>
                <!--eserler slider alanı -->
                <div id="contest-slider-2">
                    <div class="item">
                        <div class="contest-left">
                            <a data-fancybox="gallery-3"
                                href="assets/img/eserler/sesil-beatris-kalayciyan-guzel-avrat-otu-ile-oto-portre-600x900.jpg">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/eserler/sesil-beatris-kalayciyan-guzel-avrat-otu-ile-oto-portre-600x900.jpg)">
                                </div>
                            </a>
                        </div>
                        <div class="contest-right">
                            <div class="contest-title">
                                <span>Güzel Avrat Otu ile Oto Portre</span>
                                <hr>
                            </div>
                            <div class="contest-name">Sesil Beatris
                                Kalaycıyan</div>
                            <div class="contest-award">10K Üretim Desteği</div>
                            <div class="contest-slide-explain">Sanatçının natürmort kurgusu otobiyografik eserlere
                                referanslar vermesinin yanı sıra kadın kimliğinin
                                toplumsal bir aktör olarak şekillendirilmesine
                                odaklanmaktadır. Ayakkabıyı çevreleyen dikenli taç ve
                                güzel avrat otu (Bella Donna) bitkisi; kadın kimliğinin
                                dil bilim içerisinde de ölümcül, tehlikeli kavramlarla
                                özdeşleştirilmesine gönderme yapmaktadır. Yastık,
                                hem eve dair konfor alanı etkisi yaratırken hem de üzerine
                                yerleştirilen nesne için bir teşhir alanıdır.
                                Kalaycıyan’ın eseri bir kız çocuğunun büyüme evresinde
                                maruz kaldığı kadınlık rolleri içerisinde yaşadığı anın
                                bir resmini çizer. Bu yüzden de onu çevreleyen
                                kültürel kodlar aynı natürmort geleneğinde kullanılan
                                nesneler gibi metaforik olarak cansızdır.</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left">
                            <a data-fancybox="gallery-4"
                                href="assets/img/eserler/funda-cetgin-hep-birlikte-600x900.jpg">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/eserler/funda-cetgin-hep-birlikte-600x900.jpg)">
                                </div>
                            </a>
                        </div>
                        <div class="contest-right">
                            <div class="contest-title">
                                <span>Hep Birlikte</span>
                                <hr>
                            </div>
                            <div class="contest-name">Funda Çetgin</div>
                            <div class="contest-award">10K Üretim Desteği</div>
                            <div class="contest-slide-explain">
                                Funda Çetgin’e göre içinde bulunduğumuz salgın
                                sürecinde insanlık, geçmişle şimdiki arasındaki
                                yaşayış biçimlerini karşılaştırarak geçmişi “normal”
                                olarak tanımlamıştır. <br><br>
                                İnsanlık, yerkürenin herhangi bir noktasında değişen
                                tek bir hayatın birkaç hafta içinde tüm dünyayı saran
                                korkutucu bir salgına dönüştüğünü çok acı bir şekilde
                                deneyimledi, tüm siyasi ve ekonomik çıkarları bir kenara
                                bırakarak en temel kaygımızın “hayatta kalmak”
                                olduğunu televizyonlardan izledi.<br><br>
                                Gelecekte ne olacağını bilemiyoruz ancak olası tüm
                                senaryolara karşı insanlığın hep birlikte hareket etmesi
                                gerektiğini artık öğrendik.
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left">
                            <a data-fancybox="gallery-5"
                                href="assets/img/eserler/ozgur-balli-grotesk-palyaco-600x900.jpg">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/eserler/ozgur-balli-grotesk-palyaco-600x900.jpg)">
                                </div>
                            </a>
                        </div>
                        <div class="contest-right">
                            <div class="contest-title">
                                <span>Grotesk Palyaço</span>
                                <hr>
                            </div>
                            <div class="contest-name">Özgür Ballı</div>
                            <div class="contest-award">10K Üretim Desteği</div>
                            <div class="contest-slide-explain">Günümüzde toplumsal düzeyde gittikçe groteskleşen
                                bir sosyal kültürün varlığı üzerine özgün bir çıkarım
                                yapılarak palyaço imgesi üzerinden bir heykel çalışması
                                ele alınmıştır. Dünyayı yabancılaştıran ve onu eğlenceli
                                hayali bir alana götüren, içinde esrarengiz, tekin olmayan
                                güçlerin egemenliğinin yansıdığı, aslında bir araya
                                gelmez gibi görünen şeylerin -trajikle komiğin, adilikle
                                yüceliğin- birleştirilmesi ile oluşturulan bu çalışma
                                grotesk kavramını ve palyaço imgesini günümüzde
                                tekrardan birlikte adlandırılma olasılığını sorgulatma
                                çabasındadır.</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left">
                            <a data-fancybox="gallery-6"
                                href="assets/img/eserler/koray-biyikli-dar-alanda-kisa-paslasmalar-600x900.jpg">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/eserler/koray-biyikli-dar-alanda-kisa-paslasmalar-600x900.jpg)">
                                </div>
                            </a>
                        </div>
                        <div class="contest-right">
                            <div class="contest-title">
                                <span>Dar Alanda Kısa Paslaşmalar III</span>
                                <hr>
                            </div>
                            <div class="contest-name">Koray Bıyıklı</div>

                            <div class="contest-slide-explain">2017 yılında başlayan <b>“Dar Alanda Kısa Paslaşmalar
                                    I”</b>
                                adlı fotoğraf deformasyonundan oluşan serinin
                                devamı niteliğindeki bu çalışmada; futbol sahasının
                                birebir ölçekli hali metallerle deforme edilerek,
                                asıl işlevini yitirmiş bir saha yaratmak istenmiştir.
                                Oyun alanının kurallarını belirleyen bu sınırlar,
                                çalışmada gerçek anlamından koparılarak izleyiciyi
                                yeni bir oyun alanına davet eder. Oynanamaz
                                bir saha olması, sınırlarının bozuk formu,
                                kent içinde sıkışan çocukluğa gönderme yapar.</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left">
                            <a data-fancybox="gallery-7" href="assets/img/eserler/muzaffer-tuncer-omurga-600x900.jpg">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/eserler/muzaffer-tuncer-omurga-600x900.jpg)">
                                </div>
                            </a>
                        </div>
                        <div class="contest-right">
                            <div class="contest-title">
                                <span>Omurga</span>
                                <hr>
                            </div>
                            <div class="contest-name">Muzaffer Tuncer</div>

                            <div class="contest-slide-explain">Yaşamın anlamını arayan ve irdeleyen sevgili
                                Tezer Özlü’nün ‘‘Yeryüzüne Dayanabilmek İçin’’
                                adlı kitabında geçen, ‘’Bugünün insanının üç uzvuna
                                gereksinimi var: 1) Akıl için kafaya 2) Duygu için yüreğe
                                3) Omurgaya: Bu da kimse önünde sürünmemek için’’
                                yazısından etkilenerek omurgayı ele aldım.
                                Zeminden incelerek başlayan birim tekrarları yukarıya
                                doğru genişleyerek artar. Omurga için söylenen söz,
                                birim tekrarlarının artmasıyla dudaklara gelindiğinde,
                                yüksek sesle söyleniyormuşçasına açıktır</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left">
                            <a data-fancybox="gallery-8" href="assets/img/eserler/burak-ayvazoglu-isimsiz-600x900.jpg">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/eserler/burak-ayvazoglu-isimsiz-600x900.jpg)">
                                </div>
                            </a>
                        </div>
                        <div class="contest-right">
                            <div class="contest-title">
                                <span>İsimsiz</span>
                                <hr>
                            </div>
                            <div class="contest-name">Burak Ayazoğlu</div>
                            <div class="contest-award">Yurtdışı Sanat Eğitimi</div>

                            <div class="contest-slide-explain">Bireyin baskılanması, sıkışması, ezilmesi gibi
                                kavramları gözlem noktamı oluşturacak biçimde
                                ele aldığım bu projede, üretim pratiğimin parçası
                                olan geometrik soyutlamanın keskinliği ve
                                netliğini kullanarak bu kavramları biçime
                                dönüştürme konusunda forma dair araştırmalar
                                gerçekleştirdim.</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left">
                            <a data-fancybox="gallery-9" href="assets/img/eserler/eda-ilbeyci-kabuk-600x900.jpg">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/eserler/eda-ilbeyci-kabuk-600x900.jpg)">
                                </div>
                            </a>
                        </div>
                        <div class="contest-right">
                            <div class="contest-title">
                                <span>Kabuk</span>
                                <hr>
                            </div>
                            <div class="contest-name">Eda İlbeyci</div>

                            <div class="contest-slide-explain">
                                Nereye gidersek gidelim yanımızda taşıdığımızdır
                                kabuğumuz. Bize ait ne varsa içindedir; korkular,
                                sevinçler, üzüntüler, umutlar…
                                Sahi umut var mıdır yoksa, umuda sahip olabilme
                                isteği midir bu?
                                Yaşadıklarımızın envanteridir kabuğumuz;
                                bize kalanlar, bizden alınanlar.
                                Kabuğumdan sadece bir kesit gördükleriniz;
                                siz ne anlam yüklerseniz o olacaklar.
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left">
                            <a data-fancybox="gallery-10" href="assets/img/eserler/gungor-yuksel-davet-600x900.jpg">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/eserler/gungor-yuksel-davet-600x900.jpg)">
                                </div>
                            </a>
                        </div>
                        <div class="contest-right">
                            <div class="contest-title">
                                <span>Davet</span>
                                <hr>
                            </div>
                            <div class="contest-name">Güngör Yüksel</div>

                            <div class="contest-slide-explain">Merdiven, kapı, pencere veya baca gibi öğeleri
                                işlevselliklerinden arındırarak fakat bir taraftan da
                                çağrıştırdığı işlevi de tamamen yıkmadan kullanıyorum.
                                Amacım, geçmiş, gelecek ve şimdiki zamanla
                                bir bağ kurarak, izleyiciyi, modern yapılarda
                                çıkamayacağımızı düşündüğüm bir yolculuğa
                                çıkarmaktır. </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left">
                            <a data-fancybox="gallery-11" href="assets/img/eserler/sirvan-gungormez-dcvs-600x900.jpg">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/eserler/sirvan-gungormez-dcvs-600x900.jpg)">
                                </div>
                            </a>
                        </div>
                        <div class="contest-right">
                            <div class="contest-title">
                                <span>D=C+V+S</span>
                                <hr>
                            </div>
                            <div class="contest-name">Şirvan Güngörmez</div>

                            <div class="contest-slide-explain">Eser Karl Marx'ın Artı Değer (D=C+V+S)
                                Teorisinden esinlenerek üretilmiştir.
                                İşçinin emeğini, işgücünün değerinin üzerinde
                                yarattığı ve kapitalist tarafından karşılıksız olarak
                                el konulan değerdir. Artı-değer yasası, kapitalizmin
                                ekonomik temel yasasıdır.
                                Heykelin genel kompozisyonunda kapitalizmin
                                sömürü düzenine vurgu yapılmıştır.</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left">
                            <a data-fancybox="gallery-12"
                                href="assets/img/eserler/guliclal-oner-yildiz-world-wide-web-600x900.jpg">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/eserler/guliclal-oner-yildiz-world-wide-web-600x900.jpg)">
                                </div>
                            </a>
                        </div>
                        <div class="contest-right">
                            <div class="contest-title">
                                <span>World Wide Web</span>
                                <hr>
                            </div>
                            <div class="contest-name">Güliclal Öner Yıldız</div>

                            <div class="contest-slide-explain">Duruşları öne eğilmiş, omuzları çıkmış
                                bulutlar içindeki kız çocukları bu halleriyle
                                sırtlarında “W” simgesi ile, izleyiciye
                                gözlerindeki açma/kapama tuşlarıyla
                                bakmaktadır. Sırtlarındaki “W” simgesi;
                                “World Wide Web” olarak 3 figürle birleşir.
                                Bilgisayar başında ve zihinleri internetin
                                içinde olduğunu vurgulamaktadır.
                                Teknolojinin ne denli fazla kullanıldığına
                                dikkatleri çekmek amacıyla şekillenmiş,
                                internetin 2020 yılındaki seçilmiş rengi olan
                                mavi tonları ile boyanmıştır</div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="liste-2022" class="tab-pane fade in active">
                <div class="contest-slider-head">İşte 2022'de dereceye giren eserler</div>
                <div class="contest-slider-explain">Milliyet Sanat Dergisi tarafından düzenlenen
                    “Heykelde
                    Yeni Keşifler” yarışmasında dereceye giren ve müzayede de sahipleri ile buluşan eserler. </div>
                <div class="contest-slider" id="contest-slider">
                    <div class="item">
                        <div class="contest-left"><a data-fancybox="gallery-4"
                                href="assets/img/2022/eserler/ufuk-adyin-icgorusel-yapi.jpg" tabindex="0">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/2022/eserler/ufuk-adyin-icgorusel-yapi.jpg);">
                                </div>
                            </a></div>
                        <div class="contest-right">
                            <div class="contest-title"><span>İçgörüsel Yapı</span>
                                <hr>
                            </div>
                            <div class="contest-name">Ufuk Aydın</div>
                            <div class="contest-slide-explain">“İçgörüsel Yapı” adlı eser geometrik bir heykel olarak
                                izleniyor. Yapıt, günümüzün apokaliptik döngülerinde toplumsallık ve bireysellik
                                kavramını
                                irdeliyor. Heykelin birbirini tekrar etmeyen ancak bağıntılı geometrik, dinamik formu
                                toplumların yapısı ile benzerlik kuruyor. Tam da bu noktada toplum ve birey arasındaki
                                öznel
                                bir varoluşu da girift yapılı bir heykel içindeki benzersizlik olarak tanımlıyor. Aydın,
                                eserin değişken girift yapısı ve ne yönde duracağı belirsiz strüktürü ile denge ve
                                dengesizlik, toplum ve birey arasında gizil bir
                                anlatıyı soyut bir ironi içinde sunuyor</div>
                        </div>

                    </div>
                    <div class="item">
                        <div class="contest-left"><a data-fancybox="gallery-4"
                                href="assets/img/2022/eserler/aldunsamed-sahin-ayaga-bali.jpg" tabindex="0">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/2022/eserler/aldunsamed-sahin-ayaga-bali.jpg);">
                                </div>
                            </a></div>
                        <div class="contest-right">
                            <div class="contest-title"><span>Ayağı Bağlı</span>
                                <hr>
                            </div>
                            <div class="contest-name">Abdulsamed Şahin</div>
                            <div class="contest-slide-explain">“Ayağı Bağlı” adlı heykeli, doktor kıyafetleri içinde
                                izlenen
                                bir erkek figürünün ayaklarının kuş şeklinde tasvir edilmesiyle izleniyor. Yarı insan ve
                                belki yarı hayvan bir figür ortaya çıkıyor. Göçmen kuşun hareket ivmesi ile kapitalist
                                düzlemde neredeyse köle gibi bağımlı kılınan çalışma hayatları, çoklu bir okuma
                                ihtimalini
                                mümkün kılıyor. Şahin, figürün yaşadığı gerilimli çalışma sistemini toplumsal bir anlatı
                                üzerinden irdeleyerek bugünün ürkütücü çalışma olanaklarını yine bireylere referansla
                                kurguluyor </div>
                        </div>

                    </div>
                    <div class="item">
                        <div class="contest-left"><a data-fancybox="gallery-4"
                                href="assets/img/2022/eserler/olcay-gultepe-hayalperest.jpg" tabindex="0">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/2022/eserler/olcay-gultepe-hayalperest.jpg);">
                                </div>
                            </a></div>
                        <div class="contest-right">
                            <div class="contest-title"><span>Hayalperest</span>
                                <hr>
                            </div>
                            <div class="contest-name">Olcay Gültepe</div>
                            <div class="contest-slide-explain">Hayalperes adlı heykeli modern dünyanın içinde boğulan
                                insan
                                kitlelerine çarpıcı biçimde referansta bulunuyor. Organik ve yuvarlak hatlardan oluşan
                                soyutlama bir insan figürü şeklinde göreceğimiz mavi heykel, ruhun ve zihnin sıkışmış
                                yapısı
                                içinde çaresizlik ve çözüm ihtimallerinin kaçış noktasını hayal kurmak olarak sunuyor.
                                Hayal
                                kurmak, hayallere inanmak sorunların giderilmesinde birincil çözüm odakları olarak
                                görünür
                                kılınıyor. Gültepe, geçirgen bir düş dünyasının kapılarını aralıyor</div>
                        </div>

                    </div>
                    <div class="item">
                        <div class="contest-left"><a data-fancybox="gallery-4"
                                href="assets/img/2022/eserler/EmirhanÖzkök_İris.jpg" tabindex="0">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/2022/eserler/EmirhanÖzkök_İris.jpg);">
                                </div>
                            </a></div>
                        <div class="contest-right">
                            <div class="contest-title"><span>İris</span>
                                <hr>
                            </div>
                            <div class="contest-name">Emirhan Özkök</div>
                            <div class="contest-slide-explain">“İris” adlı eser yine bir bakma, görme eyleminin somut
                                izdüşümü olarak karşımıza çıkıyor. Tamamen formal bir düzlemde ince malzemelerle soyut
                                ve üç
                                boyutlu bir göz formu olarak kurgulanan heykel, zihnin alt benliğindeki görünmeyenleri
                                çıkarma ihtimali üzerinden tedirgin edici bir tetikleyiciye dönüşüyor. Bu açıdan görmek,
                                anlamak ve zihnin düzlüklerindeki bilgiyi paylaşmak arasında görme ve iletişim
                                alışverişi
                                keskin biçimde sunuluyor.</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left"><a data-fancybox="gallery-4"
                                href="assets/img/2022/eserler/kadir-kiricinin-donence-kendini.jpg" tabindex="0">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/2022/eserler/kadir-kiricinin-donence-kendini.jpg);">
                                </div>
                            </a></div>
                        <div class="contest-right">
                            <div class="contest-title"><span>Dönence Kendini Tanı</span>
                                <hr>
                            </div>
                            <div class="contest-name">Kadir Kırıcı</div>
                            <div class="contest-slide-explain">“İris” adlı eser yine bir bakma, görme eyleminin somut
                                izdüşümü olarak karşımıza çıkıyor. Tamamen formal bir düzlemde ince malzemelerle soyut
                                ve üç
                                boyutlu bir göz formu olarak kurgulanan heykel, zihnin alt benliğindeki görünmeyenleri
                                çıkarma ihtimali üzerinden tedirgin edici bir tetikleyiciye dönüşüyor. Bu açıdan görmek,
                                anlamak ve zihnin düzlüklerindeki bilgiyi paylaşmak arasında görme ve iletişim
                                alışverişi
                                keskin biçimde sunuluyor.</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left"><a data-fancybox="gallery-4"
                                href="assets/img/2022/eserler/Filiz-Sir-Entropi.jpg" tabindex="0">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/2022/eserler/Filiz-Sir-Entropi.jpg);">
                                </div>
                            </a></div>
                        <div class="contest-right">
                            <div class="contest-title"><span>Entropi</span>
                                <hr>
                            </div>
                            <div class="contest-name">Filiz Sır</div>
                            <div class="contest-slide-explain">Filiz Sır’ın ”Entropi“ adlı heykeli, katlı bir apartman
                                gibi
                                üst üste inşa edilmiş bir yapıyı andırıyor. Kendisi başvuru metninde, “Entropi
                                parçacıkların
                                hareketleriyle birbirlerine ya da içinde bulundukları kabın cidarına çarparak daha geniş
                                alana yayılmaları sırasında ısınmaları ve düzensiz hâle gelmeleridir,” diyor. Entropi
                                kavramının odaklandığı yayılma ve dağılma işlemleri, insanların enerjiyi yönetimine
                                önemli
                                bir anlam olarak sunuluyor. Özellikle sanayi devriminden bugüne makineler, insan
                                yaşamını
                                şekillendiriyor. Sır, çok parçalı bir bütün olarak karşımıza çıkan heykelinde
                                makinelerin
                                parça-bütün ilişkisine odaklanıyor ve işlevsellik ile dünyamızın Antroposen Jeolojik
                                Çağı’na
                                referans veriyor
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left"><a data-fancybox="gallery-4"
                                href="assets/img/2022/eserler/lale-altinel-lilium.jpg" tabindex="0">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/2022/eserler/lale-altinel-lilium.jpg);">
                                </div>
                            </a></div>
                        <div class="contest-right">
                            <div class="contest-title"><span>Lilium</span>
                                <hr>
                            </div>
                            <div class="contest-name">Lale Altınel</div>
                            <div class="contest-slide-explain">Bu yılın seçkisinde mitoloji, hikâye ve insan ilişkileri
                                oldukça önemli bir yerde duruyor. Lale Altunel’in “Lilium” adlı heykeli ise zambak
                                bitkisi
                                olarak antik dönemlerden bugüne uzanan sembolik anlatıları görünür kılıyor. “Lilium”
                                (Zambak), ruhun saflığı, erdem ve masumiyet
                                arasında çiçeğin narinliğiyle kırılgan bir bağ kuruyor. Zambak, Bizans mozaiklerinden
                                Roma
                                mitolojisine ve sanatın altın çağı Rönesans’a kadar birçok noktada sembolik biçimlerde
                                anlatıları desteklemiştir. Altunel de bu çok katmanlı tarihsel ve kültürel örüntüler
                                arasında “Lilium” adlı eseri ile mitolojik anlatıları, sembolik ifadeleri görünür hâle
                                getiriyor</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left"><a data-fancybox="gallery-4"
                                href="assets/img/2022/eserler/cigdem-yildirim-athena.jpg" tabindex="0">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/2022/eserler/cigdem-yildirim-athena.jpg);">
                                </div>
                            </a></div>
                        <div class="contest-right">
                            <div class="contest-title"><span>Athena</span>
                                <hr>
                            </div>
                            <div class="contest-name">Çiğdem Yıldırım</div>
                            
                            <div class="contest-slide-explain">Çiğdem Yıldırım’ın “Athena” heykeli gökyüzünün rengini
                                almış,
                                yerde süzülen mavi bir kuş. Mitolojide baykuş, Athena’nın sembollerinden birisidir ve
                                Athena
                                sanatın, kadınların yaptığı nakışların ve incelikli eserlerin koruyucusu olarak rivayet
                                edilir. Bu mitten yola çıkan
                                Yıldırım, heykelini incelikli, meşakkatli bir dokuma üretimiyle gerçekleştiriyor ve
                                kadınların üretiminin koruyucusu Athena’ya referans veriyor</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="contest-left"><a data-fancybox="gallery-4"
                                href="assets/img/2022/eserler/furkan-Depeli-Dialogue-Khronos.jpg" tabindex="0">
                                <div class="contest-slide-image"
                                    style="background-image: url(assets/img/2022/eserler/furkan-Depeli-Dialogue-Khronos.jpg);">
                                </div>
                            </a></div>
                        <div class="contest-right">
                            <div class="contest-title"><span>Dialogue, Khronos</span>
                                <hr>
                            </div>
                            <div class="contest-name">Furkan Depeli</div>
                            
                            <div class="contest-slide-explain">Dialogue,Khronos” adlı heykelinde birey soyutlama bir
                                form
                                içinde izleniyor. Yarı kübik, çizgisel bir form ile birlikte bu formun altında
                                katlanmış,
                                ezilir gibi görünen figür zaman, mekân bağlamı içinde kendini gerçekleştirme edimi
                                üzerinden
                                dikkat çekiyor. Figürün kaotik bir insan gündemi içinde kendi varoluş kaydını zaman ve
                                mekân
                                denklemi içinde tutması önemli bir izlence olarak karşımıza çıkıyor</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- 
<div class="juryModal endModal modal fade" id="endModal" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <button class="close" data-dismiss="modal" type="button">&times;</button>
            <div class="modal-body">
                <div class="end-modal-content">
                    <div class="end-modal-logo">
                        <img src="assets/img/heykelde-sanat-poster.png" alt="Heykelde Yeni Keşifler Logo" class="img-responsive">
                    </div>
                    <div class="end-modal-text-content">
                        <div class="end-modal-head-text">
                            Yarışma başvuruları sona ermiştir. 
                        </div>
                        <div class="end-modal-explain-text">
                            Yoğun ilginiz için teşekkür ederiz.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->